import { AlertTriangle } from 'lucide-react'
import type { MissingDoseInput } from '@/types/products'
import {
  INPUTS_NOT_FOUND_HINT,
  INPUTS_NOT_FOUND_TITLE,
  inputsNotFoundLines,
} from '@/lib/limsInputs'

/**
 * The lab values a split or pool cannot find, shown above the action it blocks.
 *
 * Outside the collapsed "How the LIMS results are recalculated" panel on
 * purpose: this is why the button is disabled, and an operator must not have
 * to open an accordion to learn that.
 */
export function LimsInputsNotFound({ missing }: { missing: MissingDoseInput[] | undefined }) {
  const lines = inputsNotFoundLines(missing)
  if (lines.length === 0) return null
  return (
    <div role='alert' className='rounded-md border border-destructive/40 bg-destructive/5 px-3 py-2 text-sm'>
      <p className='flex items-center gap-2 font-medium text-destructive'>
        <AlertTriangle className='h-4 w-4 shrink-0' />
        {INPUTS_NOT_FOUND_TITLE}
      </p>
      <ul className='mt-1.5 list-disc space-y-0.5 pl-6 text-xs text-foreground'>
        {lines.map(line => (
          <li key={line}>{line}</li>
        ))}
      </ul>
      <p className='mt-1.5 text-xs text-muted-foreground'>{INPUTS_NOT_FOUND_HINT}</p>
    </div>
  )
}
